export default __webpack_public_path__ + "static/media/creditoscarbono.5c04165b.svg";